import React, { useState } from 'react';

import { EOrganization, ESnapshotExists } from 'lib/types';
import TabGroup, { TabOption } from 'lib/components/Tabs';
import SettingsPage from 'routes/settings/SettingsPage';
import { Product } from 'lib/enums';
import { PublishingMedium } from 'lib/enums/PublishingMedium';
import AdTemplateTable from './adTemplateTable';
import { LayoutSettings } from './layoutSettings';
import { Preview } from './preview';

type TemplateSettingsProps = {
  activeOrganization: ESnapshotExists<EOrganization>;
};

const TEMPLATES_TAB: TabOption = {
  label: 'Templates',
  enabled: true,
  id: 'templates-tab'
};

const LAYOUT_TAB: TabOption = {
  label: 'Layout',
  enabled: true,
  id: 'layout-tab'
};

const PREVIEW_TAB: TabOption = {
  label: 'Preview',
  enabled: true,
  id: 'preview-tab'
};

const DESIGN_AND_LAYOUT_TABS = [TEMPLATES_TAB, LAYOUT_TAB, PREVIEW_TAB];

export default function DesignAndLayoutSettings({
  activeOrganization
}: TemplateSettingsProps) {
  const [activeTab, setActiveTab] = useState(TEMPLATES_TAB);

  return (
    <SettingsPage>
      <TabGroup
        onClickTab={setActiveTab}
        activeTab={activeTab}
        tabs={DESIGN_AND_LAYOUT_TABS}
        id="newspaper-settings-design-and-layout-tabs"
      />
      {activeTab.label === TEMPLATES_TAB.label && (
        <AdTemplateTable
          activeOrganization={activeOrganization}
          productLine={Product.Notice}
          publishingMedium={PublishingMedium.Print}
        />
      )}
      {activeTab.label === LAYOUT_TAB.label && <LayoutSettings />}
      {activeTab.label === PREVIEW_TAB.label && <Preview />}
    </SettingsPage>
  );
}
